/**
 * 必須入力エラー
 * URL、HTTPメソッド、所属コード1が未入力の場合にスローされる
 * 
 * @author CAP
 */
export class NotInputError extends Error {
  constructor(message: string = '必須パラメータが入力されていません') {
    super(message);
    this.name = 'NotInputError';
    Object.setPrototypeOf(this, NotInputError.prototype);
  }
}